const styles = (theme) => {
  return {
    container: {
      display: 'grid',
      gridGap: '1em',
      alignItems: 'center'
    },
    primaryButton: {
      color: '#fff',
      fontSize: '15px',
      width: '45%',
      background: ' #2F5597',
      border: '1px solid  #2F5597',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: ' #2F5597'
      }
    },
    primaryButtonNewpassword: {
      marginTop: '1em',
      color: '#fff',
      fontSize: '20px',
      width: '100%',
      background: ' #2F5597',
      border: '1px solid  #2F5597',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: ' #2F5597'
      }
    },
    disabledPrimaryButton: {
      fontSize: '15px',
      width: '45%',
      border: '1px solid  #2F5597',
      borderRadius: '10px'
    },
    backButton: {
      marginTop: '1em',
      fontSize: '18px',
      width: '40%',
      height: '40px',
      lineHeight: '20px',
      background: '#fff',
      color: '#aaa',
      border: '1px solid  #2F5597',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: '#fff',
        color: '#aaa'
      }
    },
    linkContainer: {
      marginTop: '0.75em',
      fontSize: '2em'
    },
    buttonLink: {
      marginTop: '5px',
      background: 'none!important',
      color: '#005d67',
      border: 'none',
      padding: '0!important',
      font: 'inherit',
      borderBottom: '1px solid #005d67',
      cursor: 'pointer'
    },
    codeGrid: {
      display: 'grid',
      gridColumnGap: '10px'
    },
    textField: {
      fontSize: '1em'
    },
    simpleKeyboard: {
      width: '70%',
      position: 'absolute',
      left: '17%',
      right: '0%',
      zIndex: 999,
      bottom: '18vh'
    },
    buttonContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      position: 'absolute',
      width: '80%',
      bottom: '10%',
      left: '12%'
    },
    invalid: {
      color: 'red'
    },
    valid: {
      color: 'green'
    },
    disabledPrimaryButtonNewpassword: {
      width: '100%',
      marginTop: '1em',
      fontSize: '20px'
    },
    formFooter: {
      flexDirection: 'row',
      position: 'absolute',
      bottom: '12px',
      left: '0',
      right: '0',
      width: '700px',
      margin: '0 auto'
    }
  };
};

export default styles;
